import navscroll from '../nav/navscroll.module';

export default function() {
    var body = document.getElementsByTagName('BODY')[0];
    var backdrop = document.getElementById('backdrop');
    var isTouchScreen = false;

    // Check device
    (function() {
        if ('ontouchstart' in document.documentElement) {
            isTouchScreen = true;
        }
    })();

    if (backdrop != null) {
        backdrop.addEventListener('click', function() {
            body.classList.remove('open-mainmenu');
            body.classList.remove('is-hidden');
            body.classList.remove('open-faq');
        });
    }

    if (isTouchScreen) {
        document.addEventListener('touchend', function(event) {
            toggleNavLink(event);
            toggleMainMenu(event);
            toggleFAQOverlay(event);
        });
    } else {
        document.addEventListener('click', function(event) {
            toggleNavLink(event);
            toggleMainMenu(event);
            toggleFAQOverlay(event);
        });
    }

    function toggleNavLink(event) {
        if (!event.target.matches('.nav-link-toggle')) return;
        event.preventDefault();
        event.target.parentElement.classList.toggle('show');
        navscroll();
    }

    function toggleFAQOverlay(event) {
        if (!event.target.matches('.btn-togglefaq')) return;
        event.preventDefault();
        body.classList.toggle('open-faq');
        body.classList.remove('open-mainmenu');
        body.classList.remove('is-hidden');
    }

    function toggleMainMenu(event) {
        if (!event.target.matches('.c-mainmenutoggle__btn')) return;
        event.preventDefault();
        body.classList.toggle('open-mainmenu');
        body.classList.remove('open-faq');
        body.classList.remove('is-hidden');
    }

    const activeDropdown = document.querySelectorAll('.c-mainmenu .dropdown.active');

    if (activeDropdown.length > 0) {
        activeDropdown.forEach(function(element) {
            element.classList.add('show');
        });
    }
}
